const doc = [({"zh_tw":({"adminButtonUser":({"backToUserIndex":"返回成員列表"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;